




















import { Component, Vue, Prop } from 'vue-property-decorator'
import {EventBus} from "@/pitprojekt/event-bus";
import UserProfile from '@/components/template/UserProfile.vue'

@Component({
  components: { UserProfile }
})
export default class Toolbar extends Vue {
  toggleDrawer() {
    EventBus.$emit('toggleNavigationDrawer')
  }
}
